// CAROUSEL WITH autoplay
( function ($) {
    $(document).ready(function () {
        if($(window).width() < 768){
            additionalSlider();
        }
    });

    function additionalSlider() {
        var wraps = $('body.home section.alternate_additional_content');
        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this);
                var slider = wrap.find('.box_wrap');
                if (slider.length > 0) {
                    slider.on("init", function () {
                        lazyLoadInstance.update();
                    });
                    slider.slick({
                        autoplay: false,
                        arrows: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        dots: true,
                        infinite: false,
                        appendDots: wrap.closest('.section').find('.pager'),
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                        centerMode: true,
                        rtl: $('html').attr('dir') == 'rtl',
                    });
                }
            });
        }
    }
}(jQuery) );